// extracted by mini-css-extract-plugin
export default {"login-tabs":"login-tabs_Et3tv","tabs-item":"tabs-item_BZLaf","tabs-active":"tabs-active_WoKho","basicLogin":"basicLogin_aU_tG","scan-code":"scan-code_VdiHv"};